module.exports = __webpack_public_path__ + "img/swiper2-6.5f803f2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/findUs/swiper2-6.jpg
// module id = 357
// module chunks = 0